<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3V5.4M12 18.6V21M4 12H6.4M17.6 12H20M5.32282 5.32282L7.31277 7.31277M16.6872 7.31277L18.6772 5.32282M5.32283 18.6801L7.31277 16.6901M16.6872 16.6901L18.6772 18.6801"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
    />
    <circle
      cx="12"
      cy="12"
      r="3.3"
      stroke="currentColor"
      stroke-width="1.6"
    />
  </svg>
</template>
